import { all, spawn } from 'redux-saga/effects';
import auth from 'features/auth/redux/auth.sagas';
import sidebar from 'features/sidebar/redux/sidebar.sagas';
import adminUsersSagas from 'features/admin-users/redux/admin-users.sagas';
import adminRolesSagas from 'features/admin-roles/redux/admin-roles.sagas';
import adminPermissionsSagas from 'features/admin-permissions/redux/admin-permissions.sagas';
import getAdminLogsSaga from 'features/admin-logs/redux/admin-logs.sagas';
import headerSaga from 'features/header/redux/header.sagas';
import emailVerificationSaga from 'features/admin-email-verification/redux/email-verification.sagas';
import gcashSaga from 'features/gcash/redux/gcash.sagas';

function* sagas() {
  yield all([
    spawn(auth),
    spawn(sidebar),
    spawn(adminUsersSagas),
    spawn(adminRolesSagas),
    spawn(adminPermissionsSagas),
    spawn(getAdminLogsSaga),
    spawn(headerSaga),
    spawn(gcashSaga),
    spawn(emailVerificationSaga),
  ]);
}

export default sagas;
